// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"14b34738","241":"84859894","381":"e3d0e7ac","643":"7e14db37","962":"fa613c6c"}[chunkId] + ".chunk.css";
};